/* eslint-disable */
import moment from 'moment';
import {
  noTimeZoneShortISODate,
  reverseShortDate,
} from '../../../common/constants/datesFormat';
import deepEqual from 'deep-equal';
import {getBlockedShipments} from './showOrderUtils';

export const parseName = (name) => {
  const names = {
    'cif': 'C&&F',
    'dealer_id': 'Dealer',
    'destiny': 'Destino',
    'state': 'Estado',
    'register_state': 'Estado de Registro',
    'year_model': 'Año modelo',
  };
  return names[name];
};

export const generateNewAction = (
  order,
  currentFixedOrder,
  previosValue,
  field,
  header,
  isEditable
) => {
  return {
    'value': field === 'cif' ? parseInt(order[field], 10) : order[field],
    'orderNumber': order.orderNumberTEMS,
    'dealer_id': currentFixedOrder.dealer_id,
    'dealer_name': currentFixedOrder.dealer_name,
    'line': order.line,
    'cif': order.cif,
    'editable': order.editable,
    'keyValue': `${field === 'state' ? 'status' : (field === 'importerId' ? 'importer' : field)}`,
    'valuePrevious': `${previosValue}`,
    'sfx': order.sfx,
    'model_description': order.model,
    'master': order.master,
    'shipment': order.shipment ? (parseInt(order.shipment, 10) || null) : null,
    'isEditable': isEditable,
    'orderShipmentDate': moment(
      header.shipmentDate,
      noTimeZoneShortISODate
    ).format(reverseShortDate),
    'orderArrivalDate': moment(
      header.arrivalDate,
      noTimeZoneShortISODate
    ).format(reverseShortDate),
    'message': `<BR> - Se ha modificado el campo '${parseName(
      field
    )}' <BR> DE: ${previosValue} -----> A: ${order[field]} <BR> PEDIDO No.: ${
      order.orderNumber
    }, LINEA: ${order.line},  COLOR: ${order.externalColor},  DEALER: ${
      order.dealer_name
    }, MODELO: ${order.master}, DESC. DEL MODELO: ${order.model}, SFX: ${
      order.sfx
    }<BR>`,
  };
};

export const generateNotifications = (originsAllData, originsAllDataFixed, ordersByShipment) => {
  const blockedShipments = getBlockedShipments(originsAllDataFixed.resultDetail);
  const notifications = [];
  originsAllData.resultDetail.forEach((order) => {
    const currentFixedOrder = originsAllDataFixed.resultDetail.find(
      (orderFixed) => orderFixed.line === order.line
    );
    const isEditable = blockedShipments.includes(order.shipment);
    if (!deepEqual(currentFixedOrder, order)) {
      if (parseInt(order.cif, 10) !== parseInt(currentFixedOrder.cif, 10)) {
        notifications.push(
          generateNewAction(
            order,
            currentFixedOrder,
            currentFixedOrder.cif,
            'cif',
            originsAllData.resultHeader,
            isEditable
          )
        );
      }
      if (order.destiny !== currentFixedOrder.destiny) {
        notifications.push(
          generateNewAction(
            order,
            currentFixedOrder,
            currentFixedOrder.destiny,
            'destiny',
            originsAllData.resultHeader,
            isEditable
          )
        );
      }
      if (order.register_state !== currentFixedOrder.register_state) {
        notifications.push(
          generateNewAction(
            order,
            currentFixedOrder,
            currentFixedOrder.register_state,
            'register_state',
            originsAllData.resultHeader,
            isEditable
          )
        );
      }
      if (order.year_model !== currentFixedOrder.year_model) {
        notifications.push(
          generateNewAction(
            order,
            currentFixedOrder,
            currentFixedOrder.year_model,
            'year_model',
            originsAllData.resultHeader,
            isEditable
          )
        );
      }
      if (order.dealer_id !== currentFixedOrder.dealer_id) {
        notifications.push(
          generateNewAction(
            order,
            currentFixedOrder,
            currentFixedOrder.dealer_id,
            'dealer_id',
            originsAllData.resultHeader,
            isEditable
          )
        );
      }
      if (order.importerId !== currentFixedOrder.importerId) {
        notifications.push(
          generateNewAction(
            order,
            currentFixedOrder,
            currentFixedOrder.importerId,
            'importerId',
            originsAllData.resultHeader,
            isEditable
          )
        );
      }
      if (order.shipment !== currentFixedOrder.shipment) {
        notifications.push(
          generateNewAction(
            order,
            currentFixedOrder,
            currentFixedOrder.shipment ? (parseInt(currentFixedOrder.shipment, 10) || null) : null,
            'shipment',
            originsAllData.resultHeader,
            isEditable
          )
        );
      }
    }
  });
  return notifications;
};
